import { gql } from "@apollo/client";

export const VALIDAR_CREAR_PEDIDO = gql`
    query validarCrearPedido (
        $idEvaluacion: Int!
    ){
        validarCrearPedido (
            idEvaluacion: $idEvaluacion
        ){
            success
            error
            valorEsperado
        }
    }
`;